import { RoleDetails } from '@unistocks/features/admin/components/role-management/role-details';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function RoleManagementDetailsPage() {
  const { id } = useLocalSearchParams<{ id: string }>();

  return (
    <>
      <Head>
        <title>{t('AbpIdentity::Roles')}</title>
      </Head>
      <RoleDetails id={id} />
    </>
  );
}
